import apiClient, { getApiErrorMessage } from './apiClient';

const unwrapApiData = (data) => data?.data || data?.Data || data;

const unwrapApiList = (data) => {
  const unwrapped = unwrapApiData(data);

  if (Array.isArray(unwrapped)) {
    return unwrapped;
  }

  if (Array.isArray(unwrapped?.items)) {
    return unwrapped.items;
  }

  if (Array.isArray(unwrapped?.Items)) {
    return unwrapped.Items;
  }

  if (unwrapped && typeof unwrapped === 'object') {
    return [unwrapped];
  }

  return [];
};

export const normalizeChat = (chat) => ({
  id: chat?.Id || chat?.id,
  projectId: chat?.ProjectId || chat?.projectId,
  title: chat?.Title || chat?.title || '',
  context: chat?.Context || chat?.context || '',
  createdAt: chat?.CreatedAt || chat?.createdAt || new Date().toISOString(),
  updatedAt: chat?.UpdatedAt || chat?.updatedAt || new Date().toISOString()
});

const sortChatsByUpdatedAt = (chats) =>
  [...chats].sort((left, right) => new Date(right.updatedAt).getTime() - new Date(left.updatedAt).getTime());

export const fetchProjectChatsApi = async (projectId) => {
  try {
    const { data } = await apiClient.get(`/projects/${encodeURIComponent(projectId)}/chats`);
    return sortChatsByUpdatedAt(unwrapApiList(data).map(normalizeChat).filter((chat) => chat.id));
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Chat list request failed.'));
  }
};

export const createChatApi = async (projectId, { title = '', context = '', model = '' } = {}) => {
  try {
    const payload = {
      Title: title,
      Context: context
    };

    if (model) {
      payload.Model = model;
    }

    const { data } = await apiClient.post(`/projects/${encodeURIComponent(projectId)}/chats`, payload);

    return normalizeChat(unwrapApiData(data));
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Create chat failed.'));
  }
};

export const fetchChatByIdApi = async (chatId) => {
  try {
    const { data } = await apiClient.get(`/chats/${encodeURIComponent(chatId)}`);
    return normalizeChat(unwrapApiData(data));
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Chat request failed.'));
  }
};

export const updateChatApi = async (chatId, { title = '', context = '' } = {}) => {
  try {
    const { data } = await apiClient.put(`/chats/${encodeURIComponent(chatId)}`, {
      Title: title,
      Context: context
    });

    return normalizeChat(unwrapApiData(data));
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Update chat failed.'));
  }
};

export const deleteChatApi = async (chatId) => {
  try {
    await apiClient.delete(`/chats/${encodeURIComponent(chatId)}`);
    return chatId;
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Delete chat failed.'));
  }
};
